// extracted by mini-css-extract-plugin
export default {"readMore":"collapsible-content-module--read-more--wl98S"};